import { render, staticRenderFns } from "./GoogleLoginButton.vue?vue&type=template&id=047794fe&scoped=true"
import script from "./GoogleLoginButton.vue?vue&type=script&lang=js"
export * from "./GoogleLoginButton.vue?vue&type=script&lang=js"
import style0 from "./GoogleLoginButton.vue?vue&type=style&index=0&id=047794fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047794fe",
  null
  
)

export default component.exports